import { Type_TermsAndConditions_getInstance2t1zfiphym43 as Type_TermsAndConditions_getInstance } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { AgreementData1bovrwm0h7gbm as AgreementData } from '../../../utils/AgreementData.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { CreateProject30799kzrue0ed as CreateProject } from './CreateProject.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Section_Details_getInstance2utxmlnygugd3 as Section_Details_getInstance,
  ProjectForm1zulspgp9ne98 as ProjectForm,
} from './EditProject.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render_0,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Form39thjb3imm7id as Form } from '../../components/nav/header.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var agreement = new (AgreementData())(Type_TermsAndConditions_getInstance());
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = agreement.xfy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    get_mainPageNavigator($this.uji_1).nd6(new (CreateProject())());
  }
  return Unit_instance;
}
var CreateProjectForm$renderMainContent$slambdaClass;
function CreateProjectForm$renderMainContent$slambda() {
  if (CreateProjectForm$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor($this_renderMainContent) {
        this.uji_1 = $this_renderMainContent;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateProjectForm$renderMainContent$slambdaClass = $;
  }
  return CreateProjectForm$renderMainContent$slambdaClass;
}
function CreateProjectForm$renderMainContent$slambda_0($this_renderMainContent) {
  var i = new (CreateProjectForm$renderMainContent$slambda())($this_renderMainContent);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var CreateProjectFormClass;
function CreateProjectForm() {
  if (CreateProjectFormClass === VOID) {
    class $ {
      constructor(projectId) {
        projectId = projectId === VOID ? Companion_getInstance().m2p() : projectId;
        this.eev_1 = projectId;
        this.fev_1 = Signal().fak(Section_Details_getInstance());
        this.gev_1 = new (ProjectForm())(this.eev_1, this.fev_1);
        this.hev_1 = MemberRole_Manager_getInstance();
      }
      ucv() {
        return new (Constant())(this.gev_1.xji_1);
      }
      ug9() {
        return this.gev_1.njj_1;
      }
      bhg() {
        return this.hev_1;
      }
      rhi(_this__u8e3s4) {
        launch(_this__u8e3s4, VOID, VOID, CreateProjectForm$renderMainContent$slambda_0(_this__u8e3s4));
        render(this.gev_1, _this__u8e3s4);
      }
    }
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render_0;
    initMetadataForClass($, 'CreateProjectForm', CreateProjectForm, VOID, [ContractorPage(), Form()]);
    CreateProjectFormClass = $;
  }
  return CreateProjectFormClass;
}
//region block: exports
export {
  CreateProjectForm as CreateProjectForm34kekzdlsbod1,
};
//endregion

//# sourceMappingURL=CreateProjectForm.mjs.map
